/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Gap_FramesInputs */

const en_event_gap_frames = /** @type {(inputs: Event_Gap_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Gap (Frames)`)
};

const fr_event_gap_frames = /** @type {(inputs: Event_Gap_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écart entre événements (images)`)
};

const de_event_gap_frames = /** @type {(inputs: Event_Gap_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignislücke (Frames)`)
};

const it_event_gap_frames = /** @type {(inputs: Event_Gap_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap evento (frame)`)
};

const ru_event_gap_frames = /** @type {(inputs: Event_Gap_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разрыв между событиями (фреймы)`)
};

const es_event_gap_frames = /** @type {(inputs: Event_Gap_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brecha de eventos (fotogramas)`)
};

const zh_cn2_event_gap_frames = /** @type {(inputs: Event_Gap_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件间隙（帧）`)
};

const ja_event_gap_frames = /** @type {(inputs: Event_Gap_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントギャップ（フレーム）`)
};

const hi_event_gap_frames = /** @type {(inputs: Event_Gap_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना अंतराल (फ्रेम)`)
};

const pt_pt2_event_gap_frames = /** @type {(inputs: Event_Gap_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervalo de eventos (quadros)`)
};

/**
* | output |
* | --- |
* | "Event Gap (Frames)" |
*
* @param {Event_Gap_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_gap_frames = /** @type {((inputs?: Event_Gap_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Gap_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_gap_frames(inputs)
	if (locale === "de") return de_event_gap_frames(inputs)
	if (locale === "it") return it_event_gap_frames(inputs)
	if (locale === "ru") return ru_event_gap_frames(inputs)
	if (locale === "es") return es_event_gap_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_event_gap_frames(inputs)
	if (locale === "ja") return ja_event_gap_frames(inputs)
	if (locale === "hi") return hi_event_gap_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_event_gap_frames(inputs)
	return en_event_gap_frames(inputs)
});